import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import * as ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import App from './App';
import * as ServiceWorker from './serviceWorker';
import history from './history';

// Suppress ResizeObserver loop errors
const originalError = console.error;
console.error = (...args) => {
  const message = args[0];
  if (typeof message === 'string' && message.includes('ResizeObserver loop completed with undelivered notifications')) {
    // Suppress this specific error
    return;
  }
  originalError.apply(console, args);
};

import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.standalone.min.css';
import './style/app.sass';

const rootElement = document.getElementById('root');
if (!history.location.pathname.includes('login') && history.location.pathname !== '/customers/home/dashboard') {
  sessionStorage.setItem('returnUrl', history.location.pathname);
}
ReactDOM.render(
  <Router history={history}>
    <App />
  </Router>,
  rootElement
);

ServiceWorker.unregister();
